import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import * as fromAuthStore from 'src/app/auth/store';
import { TOKEN_KEY } from 'src/utils/constants';

@Component({
  selector: 'app-password-creating',
  templateUrl: './password-creating.component.html',
  styleUrls: ['./password-creating.component.scss'],
})
export class PasswordCreatingComponent implements OnInit {
  showPassword1: boolean = false;
  showPassword2: boolean = false;

  password: string = '';
  password_repeat: string = '';

  userEmail: string = '';
  userToken: string = this.route.snapshot.params[TOKEN_KEY];

  constructor(
    private route: ActivatedRoute,
    private authStore: Store<fromAuthStore.State>
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.userEmail = params['email'];
    });
  }

  updatePassword() {
    this.authStore.dispatch(
      new fromAuthStore.UpdatePassword({
        email: this.userEmail,
        token: this.userToken,
        password: this.password,
        password_confirmation: this.password_repeat,
      })
    );
  }
}
